
import React from 'react';

interface DashboardData {
  totalVisits: number;
  todayVisits: number;
  avgTimeOnSite: string;
  bounceRate: string;
  topPages: Array<{
    page: string;
    visits: number;
    percentage: number;
  }>;
  userInterests: Array<{
    module: string;
    clicks: number;
    percentage: number;
  }>;
  clickHeatmap: Array<{
    element: string;
    clicks: number;
    location: string;
  }>;
  visitorsLocation: Array<{
    city: string;
    visits: number;
    percentage: number;
  }>;
}

export default function Dashboard() {
  // 模拟Dashboard数据
  const dashboardData: DashboardData = {
    totalVisits: 12847,
    todayVisits: 234,
    avgTimeOnSite: '3:24',
    bounceRate: '42.5%',
    topPages: [
      { page: '首页', visits: 8934, percentage: 69.5 },
      { page: '服务页面', visits: 2156, percentage: 16.8 },
      { page: '解决方案', visits: 1234, percentage: 9.6 },
      { page: '联系我们', visits: 523, percentage: 4.1 }
    ],
    userInterests: [
      { module: '碳资产管理', clicks: 1876, percentage: 28.3 },
      { module: '碳足迹监测', clicks: 1543, percentage: 23.2 },
      { module: '绿色金融', clicks: 1234, percentage: 18.6 },
      { module: 'ESG咨询', clicks: 987, percentage: 14.9 },
      { module: '碳交易平台', clicks: 856, percentage: 12.9 },
      { module: '其他服务', clicks: 145, percentage: 2.1 }
    ],
    clickHeatmap: [
      { element: '免费咨询按钮', clicks: 543, location: '头部导航' },
      { element: '了解详情按钮', clicks: 432, location: '服务卡片' },
      { element: '立即体验按钮', clicks: 321, location: '英雄区域' },
      { element: '查看更多按钮', clicks: 298, location: '新闻区域' },
      { element: '联系方式', clicks: 267, location: '联系区域' },
      { element: '服务介绍', clicks: 234, location: '服务区域' }
    ],
    visitorsLocation: [
      { city: '北京', visits: 3421, percentage: 26.6 },
      { city: '上海', visits: 2876, percentage: 22.4 },
      { city: '深圳', visits: 1987, percentage: 15.5 },
      { city: '广州', visits: 1456, percentage: 11.3 },
      { city: '杭州', visits: 987, percentage: 7.7 },
      { city: '其他城市', visits: 2120, percentage: 16.5 }
    ]
  };

  return (
    <div className="space-y-8">
      {/* 概览卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">总访问量</p>
              <p className="text-3xl font-bold text-gray-900">{dashboardData.totalVisits.toLocaleString()}</p>
            </div>
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <i className="ri-eye-line text-blue-600 text-xl"></i>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">今日访问</p>
              <p className="text-3xl font-bold text-gray-900">{dashboardData.todayVisits}</p>
            </div>
            <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
              <i className="ri-calendar-today-line text-emerald-600 text-xl"></i>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">平均停留时间</p>
              <p className="text-3xl font-bold text-gray-900">{dashboardData.avgTimeOnSite}</p>
            </div>
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <i className="ri-time-line text-purple-600 text-xl"></i>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">跳出率</p>
              <p className="text-3xl font-bold text-gray-900">{dashboardData.bounceRate}</p>
            </div>
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
              <i className="ri-logout-circle-line text-orange-600 text-xl"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* 热门页面 */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">热门页面</h3>
          <div className="space-y-4">
            {dashboardData.topPages.map((page, index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-900">{page.page}</span>
                    <span className="text-sm text-gray-500">{page.visits.toLocaleString()}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-blue-500 h-2 rounded-full" 
                      style={{ width: `${page.percentage}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 用户兴趣模块 */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">用户感兴趣的模块</h3>
          <div className="space-y-4">
            {dashboardData.userInterests.map((interest, index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-900">{interest.module}</span>
                    <span className="text-sm text-gray-500">{interest.clicks}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-emerald-500 h-2 rounded-full" 
                      style={{ width: `${interest.percentage}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* 点击热力图 */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">点击热力图</h3>
          <div className="space-y-4">
            {dashboardData.clickHeatmap.map((item, index) => (
              <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                    <span className="text-red-600 text-sm font-medium">{index + 1}</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">{item.element}</p>
                    <p className="text-xs text-gray-500">{item.location}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium text-gray-900">{item.clicks}</p>
                  <p className="text-xs text-gray-500">次点击</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 访客地理位置 */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-6">访客地理分布</h3>
          <div className="space-y-4">
            {dashboardData.visitorsLocation.map((location, index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-900">{location.city}</span>
                    <span className="text-sm text-gray-500">{location.visits.toLocaleString()}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-purple-500 h-2 rounded-full" 
                      style={{ width: `${location.percentage}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
